module.exports = __webpack_public_path__ + "static/media/tela1.ed34f0db.png";